import { Asn } from "../asn.entity";
import { AsnDto } from "./asn.dto";

export class AsnAdapter {
    convertDtoToEntity(dtoObj: AsnDto, isUpdate: boolean = false,count,vendorPriceStatus:boolean,vendorItemMap,asnNumber:string): Asn {
        const asnDto = new Asn;
      
      
        
        return asnDto;
}

    public convertEntityToDto(asnObj: Asn): AsnDto {
        const asnDto = new AsnDto;
      
      
        
        return asnDto;
    }
}